export enum TransactionStatusEnum {
    PAID = "PAID",
    UNPAID = "UNPAID",
    ERROR = "ERROR",
    CANCELLED = "CANCELLED",
    NONE = "NONE",
}